import { useGetIntegrations } from '@ion/api';
import { useState } from 'react';
import isNil from 'lodash/isNil';

/**
 * Multiple control proxy API calls - 1x call per clusterId
 */
function useGetBulkIntegrations() {
  const [getIntegrations] = useGetIntegrations();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const useGetBulkIntegrations = async ({ clusterIds }) => {
    if (!Array.isArray(clusterIds) || clusterIds.length === 0) {
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const integrationResponses = await Promise.all(
        clusterIds.map(async clusterId => {
          const response = await getIntegrations({ clusterId });

          return {
            clusterId,
            ...response,
          };
        })
      );

      // convert responses to object w/ clusterId as key
      const responseMap = integrationResponses.reduce((acc, response) => {
        if (isNil(response?.clusterId)) {
          return acc;
        }

        acc[response.clusterId] = response;
        return acc;
      }, {});

      setResponseData(responseMap);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return [
    useGetBulkIntegrations,
    {
      loading,
      error,
      data: responseData,
    },
  ];
}

export default useGetBulkIntegrations;
